import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GatewayDetailTabType } from '../utils';

export const useGatewayDetail = () => {
  const { gatewayId, tabId } = useParams<{ projectId: string; gatewayId: string; tabId: string }>();
  const { t } = useTranslation();

  const title = `Gateway: ${(gatewayId && gatewayId) || ''}`;

  const tabItemList = [{ label: t('_GATEWAY_DETAIL_TAB_TITLE_INFO'), key: GatewayDetailTabType.INFO }];

  return {
    gatewayId,
    tabId,
    title,
    tabItemList,
  };
};
